// extracted by mini-css-extract-plugin
export default {"wrap":"RatingQrCode_wrap__5R7bH","compact":"RatingQrCode_compact__LyLs3","qr":"RatingQrCode_qr__OtBxD","label":"RatingQrCode_label__DjRoy"};